export default __webpack_public_path__ + "static/media/game-ranking.5da9352a.png";